import { render } from "./ManagerKnowledgeAreaView.vue?vue&type=template&id=01dc1a38"
import script from "./ManagerKnowledgeAreaView.vue?vue&type=script&lang=js"
export * from "./ManagerKnowledgeAreaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__